import workspaceQuery from 'graphql/queries/sales/PackageTypesWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/sales/PackageTypesListQuery.graphql';
import instanceQuery from 'graphql/queries/sales/PackageTypesQuery.graphql';
import defaultQuery from 'graphql/queries/sales/PackageTypesDefault.graphql';
import mutationQuery from 'graphql/mutations/sales/PackageTypesMutation.graphql';
import fragment from 'graphql/fragments/sales/PackageTypesFragment.graphql';

const PackageType = {
  type: 'PackageType',
  title: 'Package Types',
  formTitle: 'Package Type',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
};

export default PackageType;
